import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { mapWidget } from "./map.variants";

export type LocationProps = {
  lat: number;
  lng: number;
};

export type UseMapWidgetProps = {
  className?: string;
  mapId?: string;
  zoom?: number;
  location: LocationProps;
};

export const useMapWidget = (props: UseMapWidgetProps) => {
  const { className = "", mapId = "map", location, zoom = 14 } = props;

  const map = useMap();
  const styles = mapWidget();

  useEffect(() => {
    if (!map) return;
    map.panTo(new google.maps.LatLng(location.lat, location.lng));
  }, [location.lat, location.lng, map]);

  return {
    styles,
    className,
    mapId,
    location,
    zoom,
  };
};
